var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTable',{staticClass:"card",attrs:{"header":_vm.header,"items":_vm.items,"fields":_vm.fields,"loading":_vm.loading,"error":_vm.error,"total-rows":_vm.offers.max},scopedSlots:_vm._u([{key:"cell(name)",fn:function(data){return [_c('b-link',{attrs:{"to":_vm.createItemUrl(data.item)}},[_vm._v(" "+_vm._s(data.item.name)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }